/* Stylesheet */

.filter_toolbar {
  display: flex;
  align-items: center;
  gap: 6px;
}
